module.exports = __webpack_public_path__ + "static/media/app-store.58221c72.svg";